class InstalatorRegistrationConfirmUsersController {
    static controller($scope) {
        'ngInject';
    };
}

export default InstalatorRegistrationConfirmUsersController.controller;


// WEBPACK FOOTER //
// ./src/users/instalator/instalator-registration-confirm.users.controller.js